module.exports = __webpack_public_path__ + "img/IBERDROLA.9d22a5d1.png";